export default {
  default: () => import("/builds/common/careers/careers-static/layouts/default.vue").then(m => m.default || m)
}